import {Component, EventEmitter, OnInit, Output } from '@angular/core';
// import {NotificationService} from '../../shared/services/notification.service';
import {HttpParams} from '@angular/common/http';
// import {UserService} from '../../modules/permission/user/user.service';
// import {Subject} from 'rxjs/Subject';
// import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
// import {SubSink} from 'subsink';
// import * as _ from 'lodash';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {

  @Output() submitted = new EventEmitter();
  newComment = '';
  constructor() { }

  ngOnInit() {
  }

  addComment() {
    const comment = [{newComment: this.newComment}];
    this.submitted.emit(comment);
    setTimeout(() => {
      this.newComment = '';
    }, 600);
  }
  handleEnterKey($event) {
    $event.preventDefault();
    this.addComment();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/comment/comment.component.ts